import { render, staticRenderFns } from "./ReportUploads.vue?vue&type=template&id=65c7caaf&"
import script from "./ReportUploads.vue?vue&type=script&lang=js&"
export * from "./ReportUploads.vue?vue&type=script&lang=js&"
import style0 from "./ReportUploads.vue?vue&type=style&index=0&id=65c7caaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports